import { Component, Input, OnInit } from '@angular/core';
import { each } from 'lodash';
import { combineLatest, Observable, Subject } from 'rxjs';
import 'rxjs/add/operator/takeUntil';
import { StudentCollectionsMergeService } from '../../../shared/services/student-collections-merge/student-collections-merge.service';

import { FlagsFilterService } from '../../../shared/services/filter-services/flags-filter.service';
import { IFlag } from '../../../shared/typings/interfaces/flags.interface';
import { IMilestone } from '../../../shared/typings/interfaces/milestones.interface';
import { ISchool } from '../../../shared/typings/interfaces/school.interface';
import { IStudent } from '../../../shared/typings/interfaces/student.interface';
import { IUser } from '../../../shared/typings/interfaces/user.interface';
import { PostsecondaryListService } from './postsecondary-list.service';

@Component({
  selector: 'nvps-postsecondary-list',
  template: require('./postsecondary-list.component.html'),
})
export class PostsecondaryListComponent implements OnInit {
  public calculatedStatusKey: string;
  public postsecStudents$: Observable<any>;
  public destroy$: Subject<boolean> = new Subject<boolean>();

  @Input() currentSchool: ISchool;
  @Input() currentUser: IUser;
  @Input() madlibOptions$: Observable<any>;
  @Input() madlibState$;
  @Input() students$: Observable<IStudent>;
  @Input() flags$: Observable<IFlag>;
  @Input() batchActionsMode$: Observable<any>;
  @Input() calculatedFields$: Observable<any>;

  constructor(
    private flagsFilterService: FlagsFilterService,
    private postsecListService: PostsecondaryListService,
    private studentCollectionsMerger: StudentCollectionsMergeService,
  ) {
    this.calculatedStatusKey = 'calculatedStatus';
  }

  ngOnInit() {
    this.postsecStudents$ = this.mergeStudentsAndCollections(this.students$, this.calculatedFields$);
  }

  ngOnDestroy(): void {
    this.destroy$.next(true);
    this.destroy$.unsubscribe();
  }

  // @timeMethod
  setMilestones(milestones): IMilestone[] {
    const nd = new Date();
    each(milestones, (milestone: IMilestone) => {
      milestone[this.calculatedStatusKey] = this.postsecListService.getCalculatedStatus(milestone, nd);
    });
    return milestones;
  }

  setFilteredFlags(flagData: IFlag[]): IFlag[] {
    return this.flagsFilterService.getFilteredFlags(flagData, 'POSTSECONDARY');
  }

  mergeStudentsAndCollections(students$: Observable<IStudent>, calculatedFields: Observable<any>): Observable<any> {
    return combineLatest(students$, this.calculatedFields$, (students: IStudent[], calculatedFields) => {
      const pathToStudentId = `_id`;
      const studentsWithMergedCollections = this.studentCollectionsMerger.mergeCollectionsToStudents({
        students,
        collections: [
          {
            collection: calculatedFields,
            keyToAddToStudent: 'calculatedFields',
            pathToStudentId,
          },
        ],
        omitStudentIfMissing: ['calculatedFields'],
      });

      return studentsWithMergedCollections;
    });
  }
}
